<!-- <template>
    <div class="card">
        <h2 class="how-to-title">How to use ?</h2>
        <div class="how-to-container">
          <h4>It's easy:</h4>
        <ul>
          <li>click on the textarea at the top</li>
          <li>enter your prompt whatever it might be</li>
          <li>click <span class="generate">Generate</span></li>
          <li>Wait few seconds for our magic.</li>
          <li>Boom!</li>
          <li>A frame will open with your image.</li>
          <li>Then you can print, delete or try again.</li>
        </ul>
        <h3 class="examples">See examples above</h3>
        </div>
    </div>
</template> -->

<template>
<section class="works">
  <h1 class="blue">How It Works</h1>
  <p class="subtitle-center"> It's never been easier just follow the instructions below <br> and your drawing will be done in seconds</p>
  <div class="cards">
    <div class="card">
      <div class="icon">✏️</div>
      <h3 class="green">Describe Your Idea</h3>
      <p class="desc">Type anything like "Happy girl Emma is an astronaut" or "Bunny eating carrots."</p>
    </div>
    <div class="card">
      <div class="icon">🤖</div>
      <h3 class="blue">AI Instantly Draws</h3>
      <p class="desc">Child-friendly line art generated in seconds</p>
    </div>
    <div class="card">
      <div class="icon">🖍️</div>
      <h3 class="yellow">Print & Color</h3>
      <p class="desc">Download PDFs or print directly</p>
    </div>
  </div>
</section>
</template>

<script lang="ts">

import { defineComponent, ref, onMounted, PropType } from 'vue';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import User from '@/types/User';

export default defineComponent({
    name: 'HowToPanel',
    components: {},
   
    setup(props) {
        const username = ref<string>('')
        const authStore = useAuthStore();
        const { session } = storeToRefs(authStore)
        const apiUrl = process.env.VUE_APP_DJANGO_BACKEND
        
        onMounted(async () => {
            const { session } = authStore;
            if (session) {
            username.value = session.user.email || "";

            }
        })

        const Subscribe = async () => {
            console.log("Subscribing")

        }

        return {
            session,
            username,
            Subscribe,
            apiUrl,
            authStore,
        }
    },
    methods: {
  },
});

</script>

<style scoped>

.works {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
    padding-bottom: 2rem;
    border-bottom: 2px solid #f0f0f0;
    margin-bottom: 2rem;
  }


  .works h1 {
      text-align: center;
      font-size: 2.2rem;
      line-height: 1.1;
      font-weight: 800;
      margin-bottom: -5px;
  }

  .subtitle-center {
  color: #64748b;
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto 1rem auto;
}

.cards {
  flex: 1;
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;
  padding-bottom: 80px;
        }

.card {
      flex: 1;
      min-width: 100px;
      max-width: 200px;
      padding: 1rem 1rem;
      border: 2px solid white;
      box-shadow: 
      0 15px 30px rgba(0, 0, 0, 0.15),
        0 0 0 6px rgba(255, 255, 255, 0.9);
      border-radius: 10px;
      text-align: center;
      position: relative;
      overflow: hidden;
  }

  .desc {
      font-size: 0.9rem;
      margin-right: 0.5rem;
      flex-shrink: 0
  }

.button-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    justify-content: center;
}
h2, h3 {
    text-align: center;
}

.card {
  background-color: #ffffff;
  border-radius: 12px;
  width: 88%;
  border: 2px solid #ccc;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  max-width: 400px;
  margin: 20px auto;
  padding: 20px;
}

.card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.how-to-title {
  color: #333;
  font-size: 24px;
  margin-bottom: 15px;
  text-align: center;
  position: relative;
}

.how-to-title::after {
  content: '';
  display: block;
  width: 150px;
  height: 3px;
  background-color: #578FCA;
  margin-top: 7px;
  margin-left: 99px;
}

.generate {
  background-color:  #578FCA;
  margin: 1px;
  padding: 2px 6px;
  border-radius: 4px;
  color: black;
}

.how-to-container {
  color: #555;
}

.how-to-container h4 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
}

ul {
  list-style-type: none;
  padding-left: 0;
}

li {
  margin-bottom: 10px;
  padding-left: 20px;
  position: relative;
  font-size: 14px;
  line-height: 1.6;
}

li::before {
  content: "•";
  color: #578FCA;
  font-size: 18px;
  position: absolute;
  left: 0;
  top: -2px;
}

li.example {
  color: #888;
  font-style: italic;
  margin-left: 20px;
}

li.example::before {
  content: "➤";
  color: #ff6b6b;
  font-size: 14px;
  top: 0;
}

li:hover {
  color: #333;
  cursor: default;
}

</style>


